<template>
  <div>
    <div v-if="loader">
      <Loader />
    </div>
    <div class="row datepickerwrap card">
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center" style="gap: 15px">
          <!-- <div class="datebox">
                    <datepicker placeholder="Select Start Date" v-model="startDate" :disabled="disabledDates" />
                </div>
                <div class="datebox">
                    <datepicker placeholder="Select End Date" v-model="endDate" :disabled="disabledDates" />
                </div> -->
          <div>
            <div
              class="ml-2"
              style="
                font-size: 14px;
                font-weight: 400;
                color: rgba(30, 30, 30, 1);
                margin-bottom: 2px;
              "
            >
              Date Range
            </div>
            <date-range-picker
              v-model="dateRange"
              opens="right"
              :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }"
              :min-date="minDate"
              :max-date="maxDate"
              class="date-range-control"
            >
            </date-range-picker>
          </div>
          <div class="customSelect mr-1">
            <div
              class="mb-1"
              style="
                font-size: 14px;
                font-weight: 400;
                color: rgba(30, 30, 30, 1);
              "
            >
              Platform
            </div>
            <select
              id="platform"
              class="form-control text-uppercase"
              v-model="selectedChannel"
            >
              <option
                v-for="channel of channelsList"
                :key="channel"
                :value="channel"
              >
                {{ channel }}
              </option>
            </select>
          </div>

          <div class="customSelect mr-1">
            <div
              class="mb-1"
              style="
                font-size: 13px;
                font-weight: 400;
                color: rgba(30, 30, 30, 1);
              "
            >
              Category
            </div>
            <select
              @change="updateCategory"
              id="platform"
              class="form-control text-uppercase"
              v-model="selectedCategory"
            >
              <option
                v-for="category of categoriesList[selectedChannel]"
                :key="category.key"
                :value="category.key"
              >
                {{ category.value }}
              </option>
            </select>
          </div>
          <div class="customMultiselect ml-1 mr-2 mt-2 align-items-center">
            <div
              class="mb-1"
              style="
                font-size: 14px;
                font-weight: 400;
                color: rgba(30, 30, 30, 1);
              "
            >
              Products
            </div>
            <multiselect
              v-model="selectedProducts"
              :options="productsList[selectedChannel][selectedCategory]"
              :multiple="true"
              :searchable="false"
              track-by="name"
              label="name"
              placeholder="Select Products to filter"
              selectLabel=""
              deselectLabel="Remove"
              @select="selectProduct"
              @remove="removeProduct"
              :close-on-select="false"
            >
              <template slot="option" slot-scope="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedProducts"
                />
                <span class="option__title ml-3">{{ option.name }}</span>
              </template>
            </multiselect>
          </div>
          <div class="d-flex">
            <div>
              <span
                class="mb-1"
                style="
                  font-size: 14px;
                  font-weight: 400;
                  color: rgba(30, 30, 30, 1);
                "
                >Rating
              </span>
              <select
                id="start-rating"
                v-model="leastRating"
                class="form-control text-uppercase star-select mt-1"
                data-display="☆☆☆☆☆"
              >
                <option value="1">&#11088;</option>
                <option value="2">&#11088;&#11088;</option>
                <option value="3">&#11088;&#11088;&#11088;</option>
                <option value="4">&#11088;&#11088;&#11088;&#11088;</option>
                <option value="5">
                  &#11088;&#11088;&#11088;&#11088;&#11088;
                </option>
              </select>
            </div>
            <span class="ml-3" style="margin-top: 30px"> - </span>
          </div>

          <div>
            <select
              id="end-rating"
              v-model="maxRating"
              class="form-control text-uppercase star-select mt-4"
              data-display="☆☆☆☆☆"
            >
              <option value="1">&#11088;</option>
              <option value="2">&#11088; &#11088;</option>
              <option value="3">&#11088;&#11088;&#11088;</option>
              <option value="4">&#11088;&#11088;&#11088;&#11088;</option>
              <option value="5">
                &#11088;&#11088;&#11088;&#11088;&#11088;
              </option>
            </select>
          </div>
          <div>
            <div
              class="mb-1"
              style="
                font-size: 14px;
                font-weight: 400;
                color: rgba(30, 30, 30, 1);
              "
            >
              Keyword
            </div>
            <input
              class="form-control"
              type="text"
              v-model="selectedKeyword"
              placeholder="Enter a keyword..."
            />
          </div>
        </div>
        <div class="ml-3" style="margin-top: 30px">
          <button class="btn primarycolor py-2" @click="getWordTreeData">
            Submit
          </button>
        </div>
      </div>
    </div>
    <div class="card" style="margin: 10px">
      <GChart
        v-if="chartData.length"
        @ready="onChartReady"
        type="WordTree"
        :options="chartOptions"
        :data="chartData"
        :settings="chartSettings"
      />
      <div v-show="!chartData.length" class="no-data">
        {{
          !selectedProducts.length || !selectedKeyword
            ? "Provide products and keyword to get the phrase analysis."
            : "No Data"
        }}
      </div>
      <div
        class="d-flex justify-content-end"
        style="gap: 4px; list-style: none"
        v-if="chartData.length && pagesArr.length > 1"
      >
        <button
          class="pagination-button"
          title="Previous"
          @click="setPreviousPage"
          :disabled="currentPage === pagesArr[0]"
        ></button>
        <span v-for="page in visiblePages" :key="page">
          <button
            v-if="page"
            @click="setCurrentPageData(page)"
            class="pagination-button"
            :class="{ active: currentPage === page }"
          >
            {{ page }}
          </button>
          <span v-else>...</span>
        </span>
        <button
          class="pagination-button"
          title="Next"
          @click="setNextPage"
          :disabled="currentPage === pagesArr[pagesArr.length - 1]"
        >
          >
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { GChart } from "vue-google-charts/legacy";
import Loader from "../Components/Loader.vue";
export default {
  name: "PhraseAnalyser",
  components: {
    Loader,
    Multiselect,
    Datepicker,
    GChart,
  },
  data() {
    return {
      loader: false,
      dateRange: {
        startDate: moment("2017-01-01").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      minDate: new Date(moment("2017-01-01")),
      channelsList: [],
      selectedChannel: "",
      categoriesList: [],
      selectedCategory: "",
      productsList: {},
      leastRating: "1",
      maxRating: "5",
      selectedKeyword: "",
      selectedProducts: [],
      disabledDates: {
        // to: new Date("2024-03-30"),
        from: new Date("2017-01-01"),
      },
      client: JSON.parse(localStorage.reviewUserData).data.client,
      chartOptions: {
        wordtree: {
          format: "implicit",
          type: "double",
          word: "",
        },
        maxFontSize: 26,
      },
      chartSettings: {
        packages: ["wordtree"],
      },
      chartData: [],
      rawData: [],
      columnsPerPage: 20,
      numberOfPages: 0,
      pagesArr: [],
      currentPage: 1,
    };
  },
  mounted() {
    this.$store.dispatch("DemoStore/setTimeStamp", "");
  },
  created() {
    // Create Platforms dropdown
    JSON.parse(localStorage.viewPlatformAndCategoryData).platform.forEach(
      (pf) => {
        this.channelsList.push(pf.platform_name);
      }
    );
    this.selectedChannel = this.channelsList[0];

    this.categoriesList = JSON.parse(
      localStorage.viewPlatformAndCategoryData
    ).category;
    this.selectedCategory = this.categoriesList[this.selectedChannel][0].key;

    const localProductList = JSON.parse(localStorage.demo_voc_product_list);

    this.productsList = {
      ...this.productsList,
      ...localProductList,
    };
    Object.values(this.productsList).forEach((platform) => {
      Object.values(platform).forEach((category) => {
        category.unshift({ name: "All" });
      });
    });
  },
  computed: {
    visiblePages() {
      const totalPages = this.numberOfPages;
      const currentPage = this.currentPage;
      let pages = [];

      if (totalPages <= 7) {
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        if (currentPage > 4) {
          pages.push(null);
        }

        const startPage = Math.max(2, currentPage - 2);
        const endPage = Math.min(totalPages - 1, currentPage + 2);

        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }

        if (currentPage < totalPages - 3) {
          pages.push(null);
        }
        pages.push(totalPages);
      }
      return pages;
    },
  },
  methods: {
    paginate() {
      if (this.rawData.length % this.columnsPerPage > 5) {
        this.numberOfPages = Math.ceil(
          this.rawData.length / this.columnsPerPage
        );
      } else
        this.numberOfPages = Math.floor(
          this.rawData.length / this.columnsPerPage
        );

      if (this.numberOfPages > 1) {
        for (let i = 1; i <= this.numberOfPages; i++) {
          this.pagesArr.push(i);
        }
      }

      this.setCurrentPageData();
    },
    setPreviousPage() {
      this.currentPage--;
      this.setCurrentPageData();
    },
    setNextPage() {
      this.currentPage++;
      this.setCurrentPageData();
    },
    setCurrentPageData(pageNum) {
      if (pageNum) this.currentPage = pageNum;

      let previousPage = this.currentPage - 1;

      if (this.numberOfPages === 0) {
        this.chartData = this.rawData;
        if (this.rawData.length === 1) {
          this.chartData.unshift(["Phrases"]);
        }
      } else {
        if (this.currentPage === this.pagesArr[this.pagesArr.length - 1]) {
          this.chartData = this.rawData.slice(
            previousPage * 20,
            this.rawData.length
          );
        } else {
          this.chartData = this.rawData.slice(
            previousPage * 20,
            this.currentPage * 20
          );
        }
      }
    },
    updateChannel() {
      this.selectedCategory = this.categoriesList[this.selectedChannel][0].key;
      // this.selectedProducts = []
    },
    updateCategory() {
      this.selectedProducts = [];
    },
    selectProduct(selectedOption) {
      if (selectedOption.name === "All") {
        this.selectedProducts =
          this.productsList[this.selectedChannel][this.selectedCategory];
      } else return;
    },
    removeProduct(removedOption) {
      if (removedOption.name === "All") {
        this.selectedProducts = [];
      } else return;
    },
    onChartReady() {
      this.loader = false;
    },
    getWordTreeData() {
      this.updateChannel();
      // Validation for required fields
      if (!this.selectedProducts.length) {
        this.$bvToast.toast(`Please select at least one product.`, {
          title: "Weavr Sense",
          variant: "danger",
          toaster: "b-toaster-top-right",
          autoHideDelay: 3000,
        });
        return;
      }
      if (!this.selectedKeyword) {
        this.$bvToast.toast(`Please provide a keyword.`, {
          title: "Weavr Sense",
          variant: "danger",
          toaster: "b-toaster-top-right",
          autoHideDelay: 3000,
        });
        return;
      }

      // Reset data fields
      this.chartData = [];
      this.rawData = [];
      this.pagesArr = [];
      this.chartOptions.wordtree.word = this.selectedKeyword;
      this.loader = true;

      // Payload preparation & data fetching
      const url = "/api/v2/phrase_analyzer";
      const payload = {
        client: this.client,
        channel: [],
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        keyword: this.selectedKeyword,
        least_rating: this.leastRating,
        max_rating: this.maxRating,
        products: [],
        category: this.selectedCategory,
      };
      this.selectedProducts.filter((eachProduct) =>
        payload.products.push(eachProduct.name)
      );
      this.selectedChannel === "All"
        ? (payload.channel = this.channelsList)
        : payload.channel.push(this.selectedChannel);

      this.$http
        .post(url, payload)
        .then((res) => {
          this.rawData = res.data.data;
          if (!this.rawData.length) {
            this.loader = false;
            return;
          }
          this.paginate();
        })
        .catch((err) => {
          console.log(err);
          this.$bvToast.toast(`Error: Check console for detailed info.`, {
            title: "Weavr Sense",
            variant: "danger",
            toaster: "b-toaster-top-right",
            autoHideDelay: 3000,
          });
          this.loader = false;
        });
    },
  },
};
</script>
<style scoped>
.pagination-button {
  padding-inline: 6px;
  padding-block: 2px;
  cursor: pointer;
  border: 1px solid var(--primary_brand-80);
  border-radius: 4px;
  min-width: 30px;
  text-align: center;
  color: var(--primary_brand);
  background-color: white;
}

.pagination-button:disabled {
  background-color: rgb(198, 200, 202);
  cursor: not-allowed;
  color: white;
  font-weight: 600;
  border: 1px solid rgb(198, 200, 202);
}

.pagination-button.active {
  color: white;
  background-color: var(--primary_brand-80);
  font-weight: 600;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

.date-range-control {
  border-radius: 5px !important;
  padding: 5px 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 0px !important;
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}

.customMultiselect {
  width: 300px;
  max-width: 300px;
}

@media (max-width: 1650px) {
  .customMultiselect {
    width: 250px;
    max-width: 250px;
  }
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 14px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

.navigationButtonSmall {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 12px;
  font-weight: bold;
  padding: 0px 10px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButtonSmall:hover {
  background: var(--accent_color-80);
}

.inner-row:not(:last-child) {
  border-bottom: 1px solid var(--base_color-20) !important;
}

.inner-cols {
  width: 10% !important;
}

@media (max-width: 1450px) {
  .inner-cols {
    width: 12% !important;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.customMultiselect .multiselect__placeholder {
  margin-bottom: 6px !important;
  padding: 0px !important;
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  max-height: 36px !important;
  overflow-y: auto;
  overflow-x: hidden;
  font-family: "poppins";
}

.customMultiselect .multiselect__input {
  border: var(--base_color-20) !important;
  height: 30px !important;
}

.customMultiselect .multiselect__input:focus {
  outline: none !important;
}

.customMultiselect .multiselect__select {
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
  top: 56% !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag {
  background: var(--primary_brand-80) !important;
  margin-bottom: 0px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
  color: #fff !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
  border: 1px solid var(--base_color-40) !important;
  border-top: none !important;
  font-family: "poppins";
}

.customMultiselect
  .multiselect__option--selected.multiselect__option--highlight {
  background: var(--red) !important;
  color: var(--white) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
  background: var(--base_color-20) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__element {
  color: var(--primary_brand-80) !important;
  border-bottom: 1px solid var(--base_color-20);
  font-family: "poppins";
}

.customMultiselect .multiselect__option--group {
  background-color: #44777a !important;
  color: white !important;
  font-size: 16px;
}

.customMultiselect .multiselect__option--highlight::after {
  font-size: 10px !important;
  padding-inline: 6px !important;
}

/* width */
.customMultiselect ::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
  background: var(--base_color-20);
  border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

.modal-title {
  font-weight: 600 !important;
  font-family: "poppins" !important;
}

.modal-header {
  background: var(--primary_brand-20) !important;
  color: var(--base_color) !important;
  border: none !important;
  font-family: "poppins" !important;
  border-radius: 5px 0px 0px 0px !important;
  word-break: break-all;
}

.modal-header .close {
  color: black !important;
  text-shadow: none !important;
  position: absolute !important;
  top: -2px !important;
  right: -6px !important;
  font-size: 30px !important;
  background: var(--primary_brand-10) !important;
  opacity: inherit !important;
  padding: 5px 10px !important;
  border-radius: 25px !important;
}
</style>
